import React, { forwardRef } from 'react';

interface HorizontalBarProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: string;
  height?: string;
  barColour?: string;
  radius?: string;
}

const HorizontalBar = forwardRef<HTMLDivElement, HorizontalBarProps>(
  ({ width, height, barColour, radius, ...props }, ref) => {
    return (
      <div
        ref={ref}
        style={{
          width: width || '4rem',
          height: height || '0.4rem',
          backgroundColor: barColour || '#d9d9d9',
          borderRadius: radius || '0.8rem',
        }}
        {...props}
      />
    );
  },
);

HorizontalBar.displayName = 'HorizontalBar';

export default HorizontalBar;
